import { API } from 'aws-amplify';
import { write } from '../../common/graphql/queries';
import { PatientVisit } from './search-patients';

export const INSERT_USER_ANNOTATION = "insert_user_annotation";
export const UPDATE_USER_ANNOTATION = "update_user_annotation";
export const DELETE_USER_ANNOTATION = "delete_user_annotation";
export const INSERT_FAVORITE = "insert_favorite";
export const DELETE_FAVORITE = "delete_favorite";
export const INSERT_FAVORITE_LIST = "insert_favorite_list";
export const DELETE_FAVORITE_LIST = "delete_favorite_list";
export const INSERT_RECENT = "insert_recent";
export const INSERT_NOTE = "insert_note";
export const UPDATE_LLM_VISIT_FEEDBACK = "update_llm_visit_feedback";
export const LLM_DASHBOARD_UPLOAD_CONTEXT = "llm_dashboard_upload_context";
export const UPSERT_ACTIONABLE_ITEM = "upsert_actionable_item";
export const UPDATE_ACTIONABLE_ITEM_STATUS = "update_actionable_item_status";
export const INSERT_ACTIONABLE_ANSWER = "insert_actionable_answer";
export const UPDATE_ACTIONABLE_ANSWER = "update_actionable_answer";
export const DELETE_ACTIONABLE_ANSWER = "delete_actionable_answer";

export const UPDATE_NEXT_STEP = "update_next_step";
export const DELETE_NEXT_STEP = "delete_next_step";
export const INSERT_USER_EVENT = "insert_user_event";
export const INSERT_FOLLOWED_PATIENT = "insert_followed_patient";
export const DELETE_FOLLOWED_PATIENT = "delete_followed_patient";
export const UPDATE_LAST_VIEWED_PATIENT_FILE = "update_last_viewed_patient_file";
export const GET_AND_UPDATE_LAST_VIEWED_SCAN_MULTI = "get_and_update_last_viewed_scan_multi";
export const UPDATE_LAST_VIEWED = "update_last_viewed";
export const LIDIA_CREATE_CONVERSATION = "lidia_create_conversation";
export const LIDIA_INITIATE_ACTIVITY = "lidia_initiate_activity";
export const LIDIA_CLOSE_CONVERSATION = "lidia_close_conversation";
export const LIDIA_DELETE_CONVERSATION = "lidia_delete_conversation";
export const LIDIA_ENROLL_PARTICIPANT = "lidia_enroll_participant";
export const LIDIA_UPDATE_PARTICIPANT_STATUS = "lidia_update_participant_status";
export const LIDIA_ACKNOWLEDGE_ALERT = "lidia_acknowledge_alert";

export const SCAN_MULTI = "scan_multi";
export const SCAN_ADMIT_DC = "scan_admit_dc";
export const SCAN_REVISIT = "scan_revisit";
export const SCAN_EDD = "scan_edd";

export const EXPERIMENTAL_EXPLAIN_PATIENT_SUMMARY = "experimental_explain_patient_summary";
export const EXPERIMENTAL_EXPLAIN_DDX = "experimental_explain_ddx";

export const EXPLAIN_ANATOMY = "explain_anatomy";
export const EXPLAIN_CHARTING = "explain_charting";
export const EXPLAIN_CURRENT_VISIT = "explain_current_visit";
export const EXPLAIN_DDX = "explain_ddx";
export const EXPLAIN_PALLIATIVE = "explain_palliative";
export const EXPLAIN_PATIENT_SUMMARY = "explain_patient_summary";
export const EXPLAIN_PHYSIOLOGY = "explain_physiology";
export const EXPLAIN_RISK = "explain_risk";
export const EXPLAIN_SX_RX = "explain_sx_rx";
export const EXPLAIN_MONITOR = "explain_monitor";
export const EXPLAIN_REVIEW_ADMIT_DC = "explain_review_admit_dc";
export const EXPLAIN_REVIEW_REVISIT = "explain_review_revisit";
export const EXPLAIN_REVIEW_EDD = "explain_review_edd";
export const EXPLAIN_SCORES = "explain_scores";
export const SCORES_FILE_TYPE = "scores";
export const EVALUATE_CAPACITY_OUTPUT = "evaluate_capacity_output";
export const LIDIA = "lidia";
export const UPDATE_USER_SETTINGS = "update_user_settings";
export const DELETE_USER_DATA = "delete_user_data";
export const DELETE_USER_DATA_BY_TYPE = "delete_user_data_by_type";
export const UPDATE_SYSTEM_BANNER = "update_system_banner";
export const CLEAR_STATUS_PAGE = "clear_status_page";
export const CREATE_RELEASE_NOTE = "create_release_note";
export const UPDATE_RELEASE_NOTE = "update_release_note";
export const DELETE_RELEASE_NOTE = "delete_release_note";
export const SCAN_TO_EXPLAIN = {
    [SCAN_MULTI]: [
        EXPLAIN_ANATOMY, EXPLAIN_CHARTING, EXPLAIN_CURRENT_VISIT, EXPLAIN_DDX, EXPLAIN_PALLIATIVE, 
        EXPLAIN_PATIENT_SUMMARY, EXPLAIN_PHYSIOLOGY, EXPLAIN_RISK, EXPLAIN_SX_RX, EXPLAIN_MONITOR,
        EXPLAIN_SCORES,
    ],
    [SCAN_ADMIT_DC]: [
        EXPLAIN_REVIEW_ADMIT_DC,
    ],
    [SCAN_REVISIT]: [
        EXPLAIN_REVIEW_REVISIT,
    ],
    [SCAN_EDD]: [
        EXPLAIN_REVIEW_EDD,
    ]
};

export const callWrite = async (input: any) => {
    try {
        const response: any = await API.graphql({
            query: write,
            variables: {
                input: JSON.stringify(input),
            }
        });
        console.log('callWrite response', response);
        return JSON.parse(response["data"]["write"]);
    } catch (err: any) {
        console.error("An error occurred while calling query", err);
        return {};
    }
}

export const markJobAsViewed = (jobName: string, patientVisit?: PatientVisit) => {
    // Mark the latest survey version as being read (if it exists)
    if (patientVisit) {
        callWrite({
            operation: UPDATE_LAST_VIEWED,
            csn: patientVisit.csn,
            jobs: [jobName],
        }).then((result: any) => {
            console.log(`Updated ${jobName} as read`);
        });
    }
}
